export enum FrameLineGeometryType {
  DoublePlanks = 'double-planks',
  SolidTube = 'solid-tube',
  SolidTubeWithEnds = 'solid-tube-with-ends',
  IBeam = 'i-beam',
  OpenAngledWeb = 'open-angled-web',
}
